export const getMonthlyValue = (val) => val && Math.round(val / 12);
